import { OrganizationUnitShiftConfig } from '@scheduling/graphql/types';
import { gql, TypedDocumentNode } from '@common/hooks';
import {
  ShiftTimesListQueryCgResponse,
  ShiftTimesListQueryVariables as ShiftTimesListQueryCgVariables,
} from '@common/graphql/schema';

export type ShiftTimesListQueryVariables = ShiftTimesListQueryCgVariables;

export const ShiftTimesList: TypedDocumentNode<
  ShiftTimesListQueryCgResponse,
  ShiftTimesListQueryVariables
> = gql`
  query ShiftTimesList(
    $organizationUnitId: ID!
    $limit: Int
    $offset: Int
    $orderField: ShiftTimesListOrderField
    $orderDirection: OrderDirection
  ) {
    shiftTimesList(
      organizationUnitId: $organizationUnitId
      limit: $limit
      offset: $offset
      orderField: $orderField
      orderDirection: $orderDirection
    ) {
      organizationUnitShiftConfigs {
        id
        startTime
        endTime
        workloadStartTime
        workloadEndTime
        lunchBreakMinLength
        lunchBreakMaxLength
        lunchBreakDeductionDefault
        duration
        lastShiftGapCreatedAt
        role {
          id
          abbreviation
        }
        workforceGroups {
          id
          name
        }
      }
      totalCount
    }
  }
`;

export type ShiftTimesListQueryResponse = {
  shiftTimesList: {
    organizationUnitShiftConfigs: OrganizationUnitShiftConfig[];
    totalCount: number;
  };
};
